function updateScroll(animate, useTimeout = true) {
  const scrollToElement = document.querySelector('.facets-vertical.page-width');
  const headerWrapper = document.querySelector('header');
  const stickyHeader = document.querySelector('sticky-header');
  
  if (!scrollToElement) return; // Exit if the target element doesn't exist

  let scrollTo = scrollToElement.offsetTop;

  // Adjust for the height of the header-wrapper if it exists
  if (headerWrapper) {
    const headerWrapperHeight = headerWrapper.offsetHeight;

    if(!stickyHeader.classList.contains('site-header--stuck')) {
      scrollTo -= (headerWrapperHeight + stickyHeader.offsetHeight);
    } else {
      scrollTo -= Math.max(headerWrapperHeight, stickyHeader.offsetHeight);
    }
  }

  

  if (animate) {
    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
  } else {
    window.scrollTo({ top: scrollTo });
  }
}



class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 300);

    const boundSubmit = (event) => {
      const target = event.target;
      const isSortSelect =
        target &&
        target.nodeName?.toUpperCase() === 'SELECT' &&
        (target.getAttribute('name') === 'sort_by' || target.name === 'sort_by');
      if (isSortSelect) {
        const selectEl = target;
        clearTimeout(this._sortSubmitScheduled);
        this._sortSubmitScheduled = setTimeout(() => {
          this._sortSubmitScheduled = null;
          this.onSubmitHandler({
            preventDefault() {},
            target: selectEl,
          });
        }, 0);
        return;
      }
      this.debouncedOnSubmit(event);
    };
    this.querySelectorAll('form').forEach((form) => {
      form.addEventListener('input', boundSubmit);
      form.addEventListener('change', boundSubmit);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.setGroupCheckboxListeners();
    this.updateGroupCheckboxStates();

  }

  setGroupCheckboxListeners() {
    this.addEventListener('change', (event) => {
      if (!event.target.matches('.filter-group_checkbox')) return;

      const groupCheckbox = event.target;
      const groupWrapper = groupCheckbox.closest('.filter-group');
      if (!groupWrapper) return;

      const childCheckboxes = groupWrapper.querySelectorAll('.filter-group__child-checkbox');

      childCheckboxes.forEach(cb => {
        if (!cb.disabled) cb.checked = groupCheckbox.checked;
      });

      this.onSubmitHandler(new Event('input', { bubbles: true, cancelable: true }));
    });
  }
  
  updateGroupCheckboxStates() {
    const groups = this.querySelectorAll('.filter-group');

    groups.forEach(group => {
      const groupCheckbox = group.querySelector('.filter-group_checkbox');
      const childCheckboxes = group.querySelectorAll('.filter-group__child-checkbox:not(:disabled)');
      if (!groupCheckbox || !childCheckboxes.length) return;

      const checkedCount = [...childCheckboxes].filter(cb => cb.checked).length;

      if (checkedCount === 0) {
        groupCheckbox.checked = false;
        groupCheckbox.indeterminate = false;
      } else if (checkedCount === childCheckboxes.length) {
        groupCheckbox.checked = true;
        groupCheckbox.indeterminate = false;
      } else {
        groupCheckbox.checked = false;
        groupCheckbox.indeterminate = true;
      }
    });
  }


  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    updateScroll(true);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        document.dispatchEvent(new CustomEvent('facetFiltersRendered'));
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    document.getElementById('main-collection-filters').innerHTML = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById('main-collection-filters').innerHTML;

    document.body.classList.remove(
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop'
    );

    document.dispatchEvent(new CustomEvent('initQuickShop'))
    
    // Re-initialize shop-the-look functionality after facet filtering
    document.dispatchEvent(new CustomEvent('STL:ItemPopupInit'))
    document.dispatchEvent(new CustomEvent('STL:mobileSliderInit'))
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-drawer', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      if (selector == '.mobile-facets__open') {
        document.querySelector(selector).outerHTML = html.querySelector(selector).outerHTML;
      } else {
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      }
      
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const formEl = event.target.closest('form');
    const isMobile = formEl?.id === 'FacetFiltersFormMobile';
    const isSortBySelect =
      event.target?.nodeName?.toUpperCase() === 'SELECT' &&
      (event.target?.getAttribute('name') === 'sort_by' || event.target?.name === 'sort_by');
    const isSortForm =
      isSortBySelect ||
      formEl?.id === 'FacetSortForm' ||
      formEl?.id === 'FacetSortDrawerForm';

    const forms = [];
    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });

    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams(forms.join('&'));
    const finalParams = new URLSearchParams();

    if (isSortForm) {
      currentParams.forEach((value, key) => {
        if (key.startsWith('filter.')) {
          finalParams.append(key, value);
        }
      });

      newParams.forEach((value, key) => {
        finalParams.set(key, value);
      });

      if (isSortBySelect) {
        finalParams.set('sort_by', event.target.value);
      }
    } else {
      newParams.forEach((value, key) => {
        if (key.startsWith('filter.')) {
          finalParams.append(key, value);
        }
      });

      currentParams.forEach((value, key) => {
        if (!key.startsWith('filter.') && !finalParams.has(key)) {
          finalParams.append(key, value);
        }
      });
    }

    this.onSubmitForm(finalParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    document.dispatchEvent(new CustomEvent('facetFiltersRendered'));
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);




if (!customElements.get('sort-by-mobile')) {
  customElements.define(
    'sort-by-mobile',
    class SortByMobile extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('change', this.onSortChange.bind(this));
      }

      onSortChange(event) {
        const sortBy = document.getElementById('SortBy-mobile');
        if (!sortBy) return;

        this.select = this.querySelector('select');
        sortBy.value = this.select.value
        sortBy.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      }
    }
  );
}

// Keep drawer sort select in sync with the mobile bar select — do not dispatch events here:
// FacetSortDrawerForm already ran onSubmitHandler; synthetic events on SortBy-mobile would
// fire a second FacetFiltersFormMobile submit (double fetch, janky UX).
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('change', function (event) {
    const sortByMobile2 = document.getElementById('SortBy-mobile-2');
    const sortByMobile = document.getElementById('SortBy-mobile');

    if (!sortByMobile2 || event.target !== sortByMobile2) return;

    if (sortByMobile && sortByMobile.value !== sortByMobile2.value) {
      sortByMobile.value = sortByMobile2.value;
      const selectedOption = sortByMobile.querySelector(
        `option[value="${CSS.escape(sortByMobile2.value)}"]`
      );
      if (selectedOption) {
        selectedOption.selected = true;
      }
    }
  });
});

class InstockButton extends HTMLElement {
  constructor() {
    super();

    this.instockCheckbox = null;
    this.instockFilter = null;
    this.filtersContainer = null;
    this.boundExternalChange = null;
    this.boundInternalChange = null;

    this.onFacetFiltersRendered = this.onFacetFiltersRendered.bind(this);
  }

  connectedCallback() {
    this.init();
    document.addEventListener('facetFiltersRendered', this.onFacetFiltersRendered);
  }

  disconnectedCallback() {
    this.cleanupListeners();
    document.removeEventListener('facetFiltersRendered', this.onFacetFiltersRendered);
  }

  onFacetFiltersRendered() {
    this.cleanupListeners();
    this.init();
  }

  init() {
    this.instockCheckbox = this.querySelector('input');
    if (!this.instockCheckbox) return;

    this.filtersContainer = document.querySelector('facet-filters-form');
    if (!this.filtersContainer) return;

    this.instockFilter = this.filtersContainer.querySelector(
      'input.mobile-facets__checkbox[name="filter.v.availability"]'
    );

    if (!this.instockFilter) return;

    this.instockCheckbox.checked = this.instockFilter.checked;

    this.boundExternalChange = () => {
      this.instockFilter.checked = this.instockCheckbox.checked;
      const form = this.instockFilter.closest('form');
      if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
    };

    this.boundInternalChange = () => {
      this.instockCheckbox.checked = this.instockFilter.checked;
    };

    this.instockCheckbox.addEventListener('change', this.boundExternalChange);
    this.instockFilter.addEventListener('change', this.boundInternalChange);
  }

  cleanupListeners() {
    if (this.instockCheckbox && this.boundExternalChange) {
      this.instockCheckbox.removeEventListener('change', this.boundExternalChange);
    }
    if (this.instockFilter && this.boundInternalChange) {
      this.instockFilter.removeEventListener('change', this.boundInternalChange);
    }
  }
}

customElements.define('instock-button', InstockButton);
